module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDCAMAAABdlVDoAAAAaVBMVEUpQqK2q8384OL5q7HtKTnybXgAI5Wrt9z////5ub/tKTnzb3rzcHvwS1nwTlvzc33//f3vRFKIlsvXz+H96+37y8/1iJH4qK/yZG/5trvzcn35t7zxV2T//P3/+frvQE7vQE//+vrwS1gB9PDeAAAABnRSTlP++vjs1ODlzsLrAAAA2ElEQVR4Ae3RVWLFQAiF4SsRZuLVuO1/ke3TCakLVPk38CGHXccT6xywwjD4eIeIFxPLeVaS+o9niCGGGGKIIYYY8kRZvitTQYqSWGWhgkCBIY1UTIFRPYVc8C6vWNc3rNvaP6ppocAouqeQ/o15hNwABUbpnkL8x3MEBQbJI1BgKCBQYCggUGAoIFBgKCE0Tv6+eSH63Zuo/wRG20IRR2AMAxRxBAYRFHFkMzZFGmlgMKUTRioYTKmEEWYwRRqBAUUFWfNdqzzyRP8KMcQQQwwxxBBDgi/oDuWWArpg6iWxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/wf.png
// module id = aZ+2
// module chunks = 0